import { render, staticRenderFns } from "./numberSeprator.vue?vue&type=template&id=4a4f3254"
import script from "./numberSeprator.vue?vue&type=script&lang=js"
export * from "./numberSeprator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports